
// 불량 유형 메타 (표시 순서·라벨·온도민감 여부). 확률은 제품 카탈로그에서.
export const defectThreshold = 0.5;
export const defectTypeMeta = [
  { key: 'warpage', labelKey: 'pages.moduleb.defects.warpage', tempSensitive: true },
  { key: 'shrinkage', labelKey: 'pages.moduleb.defects.shrinkage', tempSensitive: true },
  { key: 'dimension', labelKey: 'pages.moduleb.defects.dimension', tempSensitive: true },
  { key: 'surface', labelKey: 'pages.moduleb.defects.surface', tempSensitive: false },
  { key: 'shortShot', labelKey: 'pages.moduleb.defects.shortShot', tempSensitive: false },
  { key: 'flash', labelKey: 'pages.moduleb.defects.flash', tempSensitive: false },
];

// 기여 모달리티 메타 (라벨·색상·온도민감). 퍼센트는 제품 카탈로그에서.
export const contributionMeta = {
  thermal: { labelKey: 'pages.moduleb.judgment.contrib.thermal', color: '#f97316', tempSensitive: true },
  vision: { labelKey: 'pages.moduleb.judgment.contrib.vision', color: '#22c55e', tempSensitive: false },
  process: { labelKey: 'pages.moduleb.judgment.contrib.process', color: '#3B82F6', tempSensitive: false },
};

// 결함 영역 어노테이션 (제품 이미지 placeholder 좌표계 0~100) — 대표 예시
export const defectAnnotations = [
  { id: 'd1', x: 20, y: 24, w: 34, h: 26, labelKey: 'pages.moduleb.judgment.annotations.warpage', color: '#ef4444' },
  { id: 'd2', x: 60, y: 58, w: 24, h: 22, labelKey: 'pages.moduleb.judgment.annotations.shrinkage', color: '#fbbf24' },
];

// KPI 패널 (전역 누적 지표)
export const kpiPanel = {
  overallF1: 95.2,          // 종합 F1(%)
  tempRecallGain: 5.3,      // 온도민감 재현율 향상(+%p)
  totalJudged: 1284,        // 누적 판정 수
  defectRate: 4.7,          // 불량률(%)
};

// 판정 상태 배지 메타
export const judgmentBadgeMeta = {
  OK: { labelKey: 'pages.moduleb.judgment.badge.ok', color: '#22c55e', bg: 'rgba(34,197,94,0.12)' },
  NG: { labelKey: 'pages.moduleb.judgment.badge.ng', color: '#ef4444', bg: 'rgba(239,68,68,0.12)' },
};

// 최근 판정 이력 테이블 (제품 ID 포함, 15~20행)
export const judgmentHistory = [
  { shotId: 'S-10248', productId: 'P-8848', ts: '14:32:08', score: 0.66, result: 'NG', defectKey: 'warpage', contribKey: 'thermal' },
  { shotId: 'S-10247', productId: 'P-8847', ts: '14:32:03', score: 0.27, result: 'OK', defectKey: null, contribKey: null },
  { shotId: 'S-10246', productId: 'P-8846', ts: '14:31:59', score: 0.30, result: 'OK', defectKey: null, contribKey: null },
  { shotId: 'S-10244', productId: 'P-8844', ts: '14:31:51', score: 0.49, result: 'OK', defectKey: null, contribKey: null },
  { shotId: 'S-10243', productId: 'P-8843', ts: '14:31:46', score: 0.58, result: 'NG', defectKey: 'dimension', contribKey: 'process' },
  { shotId: 'S-10242', productId: 'P-8842', ts: '14:31:42', score: 0.28, result: 'OK', defectKey: null, contribKey: null },
  { shotId: 'S-10241', productId: 'P-8841', ts: '14:31:38', score: 0.57, result: 'NG', defectKey: 'warpage', contribKey: 'thermal' },
  { shotId: 'S-10240', productId: 'P-8840', ts: '14:31:33', score: 0.24, result: 'OK', defectKey: null, contribKey: null },
  { shotId: 'S-10239', productId: 'P-8839', ts: '14:31:29', score: 0.31, result: 'OK', defectKey: null, contribKey: null },
  { shotId: 'S-10238', productId: 'P-8838', ts: '14:31:25', score: 0.52, result: 'NG', defectKey: 'surface', contribKey: 'vision' },
  { shotId: 'S-10236', productId: 'P-8836', ts: '14:31:16', score: 0.63, result: 'NG', defectKey: 'shrinkage', contribKey: 'thermal' },
  { shotId: 'S-10235', productId: 'P-8835', ts: '14:31:12', score: 0.18, result: 'OK', defectKey: null, contribKey: null },
  { shotId: 'S-10234', productId: 'P-8834', ts: '14:31:08', score: 0.29, result: 'OK', defectKey: null, contribKey: null },
  { shotId: 'S-10233', productId: 'P-8833', ts: '14:31:03', score: 0.69, result: 'NG', defectKey: 'warpage', contribKey: 'thermal' },
  { shotId: 'S-10232', productId: 'P-8832', ts: '14:30:59', score: 0.22, result: 'OK', defectKey: null, contribKey: null },
  { shotId: 'S-10231', productId: 'P-8831', ts: '14:30:55', score: 0.41, result: 'OK', defectKey: null, contribKey: null },
];
